let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("XVtLY")).then(() => parcelRequire('gl9mP'));